module.exports = __webpack_public_path__ + "media/src/images/google_g_logo-66ae25beb1eb0655ac594978ee31ddb2.svg";